import { IBasicPickerValue } from 'components/foundation/pickers/basic-picker/BasicPicker/BasicPicker';
import { t } from 'i18next';
import { DocumentationRequiredPickerKey, RenewalRequiredPickerKey, EmployeeCanManagePickerKey } from './types';

export const documentationRequiredPickerData: IBasicPickerValue<DocumentationRequiredPickerKey>[] = [
  {
    id: 'documentationRequired',
    name: t('Documentation Required'),
  },
  {
    id: 'documentationNotRequired',
    name: t('Documentation Not Required'),
  },
];

export const renewalRequiredPickerData: IBasicPickerValue<RenewalRequiredPickerKey>[] = [
  {
    id: 'renewalRequired',
    name: t('Renewal Required'),
  },
  {
    id: 'renewalNotRequired',
    name: t('Renewal Not Required'),
  },
];

export const employeeCanManagePickerData: IBasicPickerValue<EmployeeCanManagePickerKey>[] = [
  {
    id: 'employeeCanManage',
    name: t('Employee Can Manage'),
  },
  {
    id: 'employeeCantManage',
    name: t(`Employee Can't Manage`),
  },
];
